import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types.ts';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import {
	ValidateTinDto,
	ValidateTinRes,
	VerifyBankIdentifiersDto,
	VerifyBankIdentifiersRes,
} from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';

// Rule-driven verification: the format rule's validationType decides which lookup
// runs server-side; omitting formatRuleId verifies the classic rule-less IBAN flow.
export const verifyBankIdentifiers = async (
	body: VerifyBankIdentifiersDto,
	options?: ServiceRequestOptions
) => {
	const response = await makeRequest<ApiV1.Response<VerifyBankIdentifiersRes>>(
		{
			endpoint: API_PATHS.VALIDATION_BANK_IDENTIFIERS_POST,
			method: HTTP_METHOD.POST,
			body: JSON.stringify(body),
		},
		{
			...options,
		}
	);

	return response;
};

export const validateTin = async (body: ValidateTinDto) => {
	const response = await makeRequest<ApiV1.Response<ValidateTinRes>>({
		endpoint: API_PATHS.VALIDATION_TIN_POST,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(body),
	});

	return response.payload;
};
